module.exports = __webpack_public_path__ + "assets/img/s2_tab2_active.72cc85ea.png";